import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useState } from 'preact/hooks'

import Toolbar from '../serp/Toolbar'
import Sidebar from '../serp/Sidebar'
import Products from '../serp/Products'
import Pagination from '../serp/Pagination'
import Loader from '../serp/Loader'
import NoResults from '../serp/NoResults'

export default () => {
    const { response: { products }, loading } = useAppState();
    const foundProducts = products && products.total > 0;
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const [ gridView, setGridView ] = useState(true); /* [for mobile] true = 2x, false = 1x */

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen)
    }

    const toggleGridView = () => {
        setGridView(prevGridView => !prevGridView)
    }

    return (
        <div class="ns-serp">
            {foundProducts ? (
                <>
                    <Toolbar
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                        gridView={gridView}
                        toggleGridView={toggleGridView}
                    />
                    <div 
                        class={`filter-container filter-container--side filter-container--mobile-initialised 
                            ${sidebarOpen ? 'filter-container--show-filters-desktop filter-container--show-filters-mobile' : ''}`
                        }
                    >
                        <Sidebar 
                            sidebarOpen={sidebarOpen}
                            toggleSidebar={toggleSidebar}
                        />
                        <Products 
                            gridView={gridView}
                        />
                    </div>
                    <Pagination />
                </>
            ) : loading ? (
                <Loader />
            ) : (
                <NoResults />
            )}
        </div>
    )
}